import { debounce } from "lodash"
import { useCallback } from "react"

export const useDebounce = (delay: number) => {
  return useCallback(
    debounce((f: () => {}) => f(), delay),
    []
  )
}
